import React from "react";
import PrivacyPolicyContainer from "../containers/privacy-policy-container";

const PrivacyPolicyPage = () => (
  <main className="privacy-policy-page">
    <PrivacyPolicyContainer />
  </main>
);

export default PrivacyPolicyPage;
